import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { listClientNewsfeed } from '../../redux/newsfeed/actions'
import { clientNewsfeedData } from '../../redux/newsfeed/selectors'
import { toggleNotes } from '../../redux/notes/actions'
import { logout, toggleSidebar } from '../../redux/profile/actions'
import {
  isClientUser,
  isDueDiligenceClient,
  isSidebarOpen,
  user,
  clientInfo,
  role,
  isPastClient,
  isAdminLoggedAsClient,
} from '../../redux/profile/selectors'
import { title } from '../../redux/ui/selectors'
import SideMenuClient from './SideMenuClient'

const selector = createStructuredSelector({
  role,
  isSidebarOpen,
  isPastClient,
  isDueDiligenceClient,
  isAdminLoggedAsClient,
  isClientUser,
  clientNewsfeedData,
  user,
  clientInfo,
  title,
})

const actions = {
  onLogout: logout,
  listClientNewsfeed,
  toggleSidebar,
  toggleNotes,
}

const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector(connector, SideMenuClient)
